import { Grid2, List, Skeleton } from '@mui/material'
import { Box } from '@mui/system'
import { Fragment } from 'react'
import { Divider, MenuListItem, SkeletonText } from 'utoniq-ui'

import { CellFrame } from '@/core/architecture'

export const ConsolePostCategoriesSkelton = () => {
  return (
    <CellFrame>
      <Box sx={{ pb: 2 }}>
        <List>
          {Array.from(Array(6).keys()).map(key => (
            <Fragment key={key}>
              <CategoryBoxSkeleton />
              <Divider sx={{ mx: 5 }} />
            </Fragment>
          ))}
        </List>
      </Box>
    </CellFrame>
  )
}

const CategoryBoxSkeleton = () => {
  return (
    <MenuListItem
      title={
        <SkeletonText
          variant="medium"
          sx={{ mt: 2, maxWidth: '200px' }}
          width={'20vw'}
        />
      }
      subTitle={
        <SkeletonText
          variant="medium"
          sx={{ mt: 2, maxWidth: '300px' }}
          width={'50vw'}
        />
      }
      sx={{
        height: 'auto',
        gridGap: 0,
        py: 4,
        color: 'text.primary',
      }}
      secondaryAction={
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 6 }}>
            <Skeleton variant="circular" width={30} height={30} />
          </Grid2>
          <Grid2 size={{ xs: 6 }}>
            <Skeleton variant="circular" width={30} height={30} />
          </Grid2>
        </Grid2>
      }
    />
  )
}
